import React, {
  useState,
  useRef,
  useMemo,
  useCallback,
  useEffect,
} from 'react';

import {
  Container,
  Content,
  ComboProps,
  ComboLocalProps,
} from 'styles/sgo_wrappers';

import { useSpring } from 'react-spring';

import SGOHeader from 'components/SGOHeader';
import SGONavbar from 'components/SGONavbar';
import ScrollTop from 'components/ScrollTop';
import SGOFooter from 'components/SGOFooter';
import Loading from 'components/Loading';
import SelectV2 from 'components/SelectV2';

import { useAuth } from 'hooks/auth';
import { useWindow } from 'hooks/window';
import { useToast } from 'hooks/toast';
import { useCredentials } from 'hooks/credentials';

import { useHistory } from 'react-router-dom';

import { calcTotal, formatNumber } from 'utils/calcTotal';
import { UpdateProps } from 'styles/dialog_update';
import * as U from 'styles/dialog_update';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import api from 'services/api';

import { alphaMasking } from 'components/Textarea/masks';

import {
  FaArrowLeft,
  FaPlusSquare,
  FaSortDown,
  FaSortUp,
  FaTimesCircle,
} from 'react-icons/fa';
import Checkbox from 'components/Checkbox';
import Textarea from 'components/Textarea';
import Button from 'components/Button';
import {
  StyledButtonPhaseOne,
  PhaseOne,
  PhaseTwo,
  PhaseThree,
  CoordContainer,
  ItemContainer,
  AddButton,
  InfoContainer,
  FinishButton,
  TotalRM,
  Grid,
  GridItem,
  DeclareNumbers,
  SpanMessage,
  DeclareButton,
  ReturnButton,
} from './styles';

interface CoordProps {
  cod: string;
  desc: string;
}

interface DMItemsProps {
  matcod: string;
  matdesc: string;
  cost: number;
  quantity: number;
  stored: number;
  require: boolean;
  numbers: string[];
  selected: string[];
}

const DMInsert: React.FC = () => {
  const phaseOne = useRef<FormHandles>(null);
  const phaseTwo = useRef<FormHandles>(null);
  const phaseThree = useRef<FormHandles>(null);

  const history = useHistory();
  const { user } = useAuth();
  const { width } = useWindow();
  const { addToast } = useToast();
  const { errorHandling, handlePermission } = useCredentials();
  const [loading, setLoading] = useState(false);

  const [comboLocs, setComboLocs] = useState<ComboProps[]>([]);

  const [mats, setMats] = useState<ComboProps[]>([]);

  const [storageQuantity, setStorageQuantity] = useState('-');
  const [cost, setCost] = useState(0);
  const [possibleNumbers, setPossibleNumbers] = useState<string[]>([]);
  const [isRequired, setIsRequired] = useState(false);

  const [dmItems, setDMItems] = useState<DMItemsProps[]>([]);

  const [isPhaseOne, setIsPhaseOne] = useState(true);
  const [isPhaseTwo, setIsPhaseTwo] = useState(false);
  const [isPhaseThree, setIsPhaseThree] = useState(false);

  const [coordSelected, setCoordSelected] = useState<CoordProps>(
    {} as CoordProps,
  );

  const [updateDiag, setUpdateDiag] = useState<UpdateProps>({
    open: false,
    content: '',
    values: {},
  });

  const totalDM = useMemo(() => {
    const total = dmItems.reduce(
      (accum, { quantity, cost: value }: DMItemsProps) => {
        const semitotal = accum + quantity * value;
        return semitotal;
      },
      0,
    );

    return total;
  }, [dmItems]);

  const faulty = useMemo(() => {
    const total = dmItems.reduce(
      (accum, { quantity, selected, require }: DMItemsProps) => {
        return require
          ? quantity === selected.length
            ? accum
            : accum + 1
          : accum;
      },
      0,
    );

    return total;
  }, [dmItems]);

  const phaseOneStyled = useSpring({
    opacity: isPhaseOne ? 1 : 0,
    transform: isPhaseOne ? 'translateX(0)' : 'translateX(60px)',
    pointerEvents: isPhaseOne ? 'all' : 'none',
    display: isPhaseOne ? 'inline' : 'none',
  });
  const phaseTwoStyled = useSpring({
    opacity: isPhaseTwo ? 1 : 0,
    transform: isPhaseTwo ? 'translateX(0)' : 'translateX(60px)',
    pointerEvents: isPhaseTwo ? 'all' : 'none',
    display: isPhaseTwo ? 'inline' : 'none',
  });
  const phaseThreeStyled = useSpring({
    opacity: isPhaseThree ? 1 : 0,
    transform: isPhaseThree ? 'translateX(0)' : 'translateX(60px)',
    pointerEvents: isPhaseThree ? 'all' : 'none',
    display: isPhaseThree ? 'inline' : 'none',
  });
  const phaseOneProceedButton = useSpring({
    opacity: coordSelected.cod ? 1 : 0,
    transform: coordSelected.cod ? 'translateX(0)' : 'translateX(60px)',
    pointerEvents: coordSelected.cod ? 'all' : 'none',
    // display: coordSelected.cod ? 'inline' : 'none',
  });
  const phaseTwoProceedButton = useSpring({
    transform:
      dmItems.length > 0 && faulty === 0
        ? 'translateX(5px)'
        : 'translateX(60px)',
    opacity: dmItems.length > 0 && faulty === 0 ? 1 : 0,
    pointerEvents: dmItems.length > 0 && faulty === 0 ? 'all' : 'none',
  });

  const toggleFlexDirection = useSpring({
    flexDirection: width < 400 && totalDM > 99.99 ? 'column' : 'row',
  });

  const getComboLOC = useCallback(async () => {
    try {
      const response = await api.get(
        `/combos/comboLOCs.php?data=${JSON.stringify({ filterStat: true })}`,
      );

      if (['NAC'].indexOf(user.perfil) > -1) {
        setComboLocs(
          response.data.filter(
            (item: ComboLocalProps) => item.anb === user.anbc,
          ),
        );
      }
    } catch (err) {
      errorHandling(err);
    }
  }, [user.perfil, user.anbc, errorHandling]);

  useEffect(() => {
    handlePermission(['NAC'], true);
    getComboLOC();
  }, [handlePermission, getComboLOC]);

  const handleCoordSelected = useCallback(() => {
    const code = phaseOne.current?.getFieldValue('coord');

    setCoordSelected({
      cod: code,
      desc:
        comboLocs[
          comboLocs.findIndex((item: ComboProps) => item.value === code)
        ].label,
    });
  }, [comboLocs]);

  const getComboMATS = useCallback(async () => {
    try {
      const response = await api.get(
        `/combos/comboMATs.php?from=dm&coordLoc=${coordSelected.cod}`,
      );
      setMats(response.data);
    } catch (err) {
      errorHandling(err);
    }
  }, [coordSelected.cod, errorHandling]);

  const handleProceedPhaseTwo = useCallback(() => {
    setIsPhaseOne(false);
    setIsPhaseTwo(true);
    getComboMATS();
  }, [getComboMATS]);

  const handleMaterialSelect = useCallback(async () => {
    try {
      setLoading(true);
      phaseTwo.current?.setErrors({});
      const material = phaseTwo.current?.getFieldValue('material');

      const send = JSON.stringify({
        matcod: material,
        trans: 'dm',
        loc: coordSelected.cod,
      });
      const response = await api.get(`/sgo/getStorage.php?data=${send}`);

      const { quantity, matcost, numbers, requireNum } = response.data;

      if (requireNum) {
        setPossibleNumbers(numbers);
      }

      setIsRequired(requireNum);
      setStorageQuantity(quantity);
      setCost(matcost);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandling(err);
    }
  }, [coordSelected.cod, errorHandling]);

  const handlePushMaterial = useCallback(() => {
    const index = mats.findIndex(
      (item: ComboProps) =>
        item.value === phaseTwo.current?.getFieldValue('material'),
    );

    phaseTwo.current?.setErrors({});

    if (parseInt(storageQuantity, 10) === 0) {
      addToast({
        type: 'info',
        title: `Este material não possui estoque`,
        description: 'Não é possível adicioná-lo',
      });
      return;
    }
    if (index > -1) {
      const newMat = {
        matcod: mats[index].value,
        matdesc: mats[index].label,
        cost,
        quantity: 1,
        stored: parseInt(storageQuantity, 10),
        require: isRequired,
        numbers: possibleNumbers,
        selected: [],
      };

      setDMItems((state) => [newMat, ...state]);
      setMats((state) =>
        state.filter((item: ComboProps) => item.value !== newMat.matcod),
      );
      setStorageQuantity('-');
      setCost(0);
      setIsRequired(false);
      setPossibleNumbers([]);
    } else {
      phaseTwo.current?.setFieldError(
        'material',
        'You must select at least one material',
      );

      addToast({
        type: 'info',
        title: ``,
        description: 'É necessário escolher um material.',
      });
    }

    phaseTwo.current?.setFieldValue('material', '');
  }, [addToast, cost, isRequired, mats, possibleNumbers, storageQuantity]);

  const handleAdd = useCallback(
    (material: string) => {
      const index = dmItems.findIndex(
        (item: DMItemsProps) => item.matcod === material,
      );

      if (index > -1) {
        dmItems[index].quantity += 1;
        setDMItems((state) => [...state]);
      }
    },
    [dmItems],
  );

  const handleSub = useCallback(
    (material: string) => {
      const index = dmItems.findIndex(
        (item: DMItemsProps) => item.matcod === material,
      );

      if (index > -1) {
        dmItems[index].quantity -= 1;
        setDMItems((state) =>
          dmItems[index].quantity === 0
            ? [...state].filter(
                (item: DMItemsProps) => item.matcod !== dmItems[index].matcod,
              )
            : [...state],
        );

        if (dmItems[index].quantity === 0) {
          const reinsert = {
            value: dmItems[index].matcod,
            label: dmItems[index].matdesc,
          };

          const rearrange = [...mats, reinsert].sort((a, b) =>
            a.label > b.label ? 1 : -1,
          );

          setMats(rearrange);
        }
      }
    },
    [dmItems, mats],
  );

  const handleInputChange = useCallback(
    (e: React.FormEvent<HTMLInputElement>, mat: string) => {
      const index = dmItems.findIndex(
        (item: DMItemsProps) => item.matcod === mat,
      );
      const number = e.currentTarget.value.replace(/^0/, '');
      if (number.length > 0) {
        const asNum = parseInt(number, 10);

        if (index > -1) {
          dmItems[index].quantity = asNum;
          setDMItems((state) =>
            dmItems[index].quantity <= 0
              ? [...state].filter(
                  (item: DMItemsProps) => item.matcod !== dmItems[index].matcod,
                )
              : [...state],
          );
        }
      } else {
        dmItems[index].quantity = 0;
        setDMItems((state) => [...state]);
      }

      e.currentTarget.value = e.currentTarget.value.replace(/^0/, '');
    },
    [dmItems],
  );

  const handleInputBlur = useCallback(
    (e: React.FormEvent<HTMLInputElement>, mat: string) => {
      const index = dmItems.findIndex(
        (item: DMItemsProps) => item.matcod === mat,
      );
      if (e.currentTarget.value === '0') {
        setDMItems((state) =>
          [...state].filter(
            (item: DMItemsProps) => item.matcod !== dmItems[index].matcod,
          ),
        );

        const material = {
          value: dmItems[index].matcod,
          label: dmItems[index].matdesc,
        };

        const rearrange = [...mats, material].sort((a, b) =>
          a.label > b.label ? 1 : -1,
        );

        setMats(rearrange);
        return;
      }

      if (parseInt(e.currentTarget.value, 10) > dmItems[index].stored) {
        dmItems[index].quantity = dmItems[index].stored;
        setDMItems((state) => [...state]);
      }
    },
    [dmItems, mats],
  );

  const handleRemoveItem = useCallback(
    (mat: string) => {
      const index = dmItems.findIndex(
        (item: DMItemsProps) => item.matcod === mat,
      );

      const reinsert = {
        value: dmItems[index].matcod,
        label: dmItems[index].matdesc,
      };

      setDMItems((state) =>
        state.filter((item: DMItemsProps) => item.matcod !== mat),
      );

      const rearrange = [...mats, reinsert].sort((a, b) =>
        a.label > b.label ? 1 : -1,
      );

      setMats(rearrange);
    },
    [mats, dmItems],
  );

  const handleDeclareClick = useCallback(
    (matcod: string, number: string) => {
      const index = dmItems.findIndex(
        (item: DMItemsProps) => item.matcod === matcod,
      );

      const exists = [...dmItems[index].selected].includes(number);

      dmItems[index].selected = exists
        ? [...dmItems[index].selected].filter((item: string) => item !== number)
        : [...dmItems[index].selected, number];

      setDMItems((state) => [...state]);
    },
    [dmItems],
  );

  const handleOBSChange = useCallback(
    (e: React.FormEvent<HTMLTextAreaElement>) => {
      const newstring = e;
      alphaMasking(newstring);

      return newstring;
    },
    [],
  );

  const handleFinish = useCallback(async () => {
    try {
      setLoading(true);

      const data = {
        dest: coordSelected,
        items: dmItems,
        // address: {
        //   value: phaseThree.current?.getFieldValue('deliver') || 'P',
        //   label: deliverAddress,
        // },
        obs: phaseThree.current?.getFieldValue('obs'),
        name: user.name,
        anbdesc: user.anbdesc,
        totalDM,
      };

      const send = new FormData();
      send.append('data', JSON.stringify(data));

      const response = await api.post('/sgo/dm_insert.php', send, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      const { dmnum } = response.data;
      addToast({
        type: 'success',
        title: 'Sucesso!',
        description: `Devolução de Material N° ${dmnum} emitida para a Coordenação ${coordSelected.desc}.`,
      });

      history.goBack();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      errorHandling(err);
    }
  }, [
    addToast,
    coordSelected,
    dmItems,
    errorHandling,
    history,
    totalDM,
    user.anbdesc,
    user.name,
  ]);

  return (
    <Container>
      <Loading isLoading={loading} />
      <ScrollTop />
      <SGOHeader />
      <SGONavbar noLinks title="Devolução de Material" />
      <Content>
        <PhaseOne style={phaseOneStyled}>
          <Form
            ref={phaseOne}
            onSubmit={() => {
              return null;
            }}
          >
            <span>
              <p>Selecione a coordenação:</p>
              <SelectV2
                name="coord"
                content={comboLocs}
                initial="Selecione"
                onChange={handleCoordSelected}
              />
            </span>
          </Form>
          <StyledButtonPhaseOne
            onClick={handleProceedPhaseTwo}
            style={phaseOneProceedButton}
            bgcolor="#00802b"
          >
            Avançar
          </StyledButtonPhaseOne>
        </PhaseOne>
        <PhaseTwo style={phaseTwoStyled}>
          <Form
            ref={phaseTwo}
            onSubmit={() => {
              return null;
            }}
          >
            <CoordContainer>
              <p>
                Coordenação: <strong>{coordSelected.desc}</strong>
              </p>
            </CoordContainer>
            <ItemContainer>
              <span>
                <SelectV2
                  name="material"
                  content={mats}
                  initial="Selecione"
                  onChange={handleMaterialSelect}
                />
              </span>
              <span>
                <p>Estoque da Local:</p>
                <strong>{storageQuantity}</strong>
              </span>
            </ItemContainer>

            <AddButton type="button" onClick={handlePushMaterial}>
              <FaPlusSquare /> <p>Adicionar material</p>
            </AddButton>
            <InfoContainer>
              <TotalRM style={toggleFlexDirection}>
                <p>Total desta devolução:&nbsp;</p>
                <strong>R$ {formatNumber(totalDM)}</strong>
              </TotalRM>

              <FinishButton
                style={phaseTwoProceedButton}
                type="button"
                onClick={() => {
                  setIsPhaseTwo(false);
                  setIsPhaseThree(true);
                }}
              >
                Avançar
              </FinishButton>
            </InfoContainer>
            <Grid>
              {dmItems.map((item: DMItemsProps) => (
                <GridItem
                  key={item.matcod}
                  required={item.require}
                  color={
                    item.selected.length < item.quantity
                      ? '#fda50f'
                      : item.selected.length === item.quantity
                      ? '#267326'
                      : '#c53030'
                  }
                >
                  <div>
                    <strong>
                      {item.matcod} - {item.matdesc}
                    </strong>
                  </div>
                  <div>
                    <span>
                      <p>
                        Custo:&nbsp;
                        <strong>R$ {formatNumber(item.cost)}</strong>
                      </p>
                    </span>
                    <span>
                      <p>Quantidade:</p>
                      <span>
                        <FaSortUp
                          onClick={() => handleAdd(item.matcod)}
                          style={{
                            transform: 'translateY(10px)',
                            color: '#009933',
                            opacity: item.stored > item.quantity ? 1 : 0,
                            pointerEvents:
                              item.stored > item.quantity ? 'all' : 'none',
                          }}
                        />

                        <input
                          type="number"
                          min={0}
                          value={item.quantity}
                          onChange={(e: React.FormEvent<HTMLInputElement>) =>
                            handleInputChange(e, item.matcod)
                          }
                          onBlur={(e: React.FormEvent<HTMLInputElement>) =>
                            handleInputBlur(e, item.matcod)
                          }
                        />

                        <FaSortDown
                          onClick={() => handleSub(item.matcod)}
                          style={{
                            transform: 'translateY(-10px)',
                            color: '#c53030',
                          }}
                        />
                      </span>
                      <figure>
                        <FaTimesCircle
                          onClick={() => handleRemoveItem(item.matcod)}
                        />
                      </figure>
                    </span>
                  </div>
                  <div>
                    <span>
                      <p>
                        Estoque da Local:&nbsp;
                        <strong>{item.stored}</strong>
                      </p>
                    </span>
                  </div>
                  <div>
                    <span>
                      <p>
                        Total:&nbsp;
                        <strong>
                          R$ {calcTotal(item.quantity, item.cost)}
                        </strong>
                      </p>
                    </span>
                  </div>
                  {item.require && (
                    <>
                      <SpanMessage
                        color={
                          item.selected.length < item.quantity
                            ? '#fda50f'
                            : item.selected.length === item.quantity
                            ? '#267326'
                            : '#c53030'
                        }
                      >
                        <p>
                          {item.selected.length === 0
                            ? 'É necessário selecionar os números controlados'
                            : item.selected.length < item.quantity
                            ? 'Quantidade selecionada é inferior a quantidade apontada'
                            : item.selected.length > item.quantity
                            ? 'Quantidade selecionada excede a quantidade apontada'
                            : ''}
                        </p>
                      </SpanMessage>
                      <div>
                        <span>
                          <DeclareButton
                            type="button"
                            onClick={() =>
                              setUpdateDiag({
                                open: true,
                                content: (
                                  <DeclareNumbers>
                                    {item.numbers.map((number: string) => (
                                      <Checkbox
                                        id={`N${number}`}
                                        title={number}
                                        onClick={() =>
                                          handleDeclareClick(
                                            item.matcod,
                                            number,
                                          )
                                        }
                                        checked={[...item.selected].includes(
                                          number,
                                        )}
                                      />
                                    ))}
                                  </DeclareNumbers>
                                ),
                                values: {
                                  matcod: item.matcod,
                                  matdesc: item.matdesc,
                                  max: item.quantity,
                                },
                              })
                            }
                          >
                            Selecionar numeração controlada
                          </DeclareButton>
                        </span>
                      </div>
                    </>
                  )}
                </GridItem>
              ))}
            </Grid>
          </Form>
        </PhaseTwo>

        <PhaseThree style={phaseThreeStyled}>
          <ReturnButton
            onClick={() => {
              setIsPhaseTwo(true);
              setIsPhaseThree(false);
            }}
          >
            <FaArrowLeft />
            <p>Retornar aos itens</p>
          </ReturnButton>
          <Form ref={phaseThree} onSubmit={() => null}>
            <div>
              <p>Observação:</p>
              <Textarea
                name="obs"
                placeholder="Insira a observação (opcional)"
                onChange={(e: React.FormEvent<HTMLTextAreaElement>) =>
                  handleOBSChange(e)
                }
              />
            </div>
          </Form>

          <Button onClick={handleFinish} bgcolor="#00802b">
            Finalizar
          </Button>
        </PhaseThree>

        <U.Container scroll="paper" maxWidth={false} open={updateDiag.open}>
          <U.Title>
            <h2>{updateDiag.values?.matdesc || 'Material'}</h2>
          </U.Title>
          <U.Content>{updateDiag.content}</U.Content>
          <U.Actions>
            {/* <U.Cancel
              type="button"
              onClick={() => setUpdateDiag({ open: false })}
            >
              Cancelar
            </U.Cancel> */}
            <U.Confirm
              type="button"
              onClick={() => setUpdateDiag({ open: false })}
            >
              Confirmar
            </U.Confirm>
          </U.Actions>
        </U.Container>
      </Content>
      <SGOFooter />
    </Container>
  );
};

export default DMInsert;
